import './_product-card-video.scss';

export default () => {};
